module.exports = __webpack_public_path__ + "static/media/rule_mm.050fdd53.png";